export enum CaslEnums {
  Access = 'access',
  All = 'all',
  HierarchySettings = 'Hierarchy Settings',
  ManageAccessRights = 'Access Rights',
}
